import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";

import {

    GET_DETAIL_GAS_PERFORMANCE_REPORT,
    baseUrl,
} from "../../../helpers/url_api_constant";

import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import Select from "react-select";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";

function TabTSO(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    let history = useHistory();
    let { year } = useParams();
    const dispatch = useDispatch();
    const permission = getPermission();
    const [pageAdd, setPageAdd] = useState(false);
    const [modelDeviceList, setModelDeviceList] = useState([]);

    const [modelListIndustrial, setModelListIndustrial] = useState([]);
    const [modelListWholesale, setModelListWholesale] = useState([]);

    const [listUser, setListUser] = useState([]);
    const [dropDownUser, setDropDownUser] = useState(null);

    //Sort Page//
    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total ms-2">
            Showing {from} to {to} of {size} Results
        </span>
    );
    // 
    const options = {
        paginationSize: 4,
        pageStartIndex: 1,
        // alwaysShowAllBtns: true, // Always show next and previous button
        // withFirstAndLast: false, // Hide the going to First and Last page button
        // hideSizePerPage: true, // Hide the sizePerPage dropdown always
        // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [
            {
                text: "100",
                value: 100,
            },
            {
                text: "250",
                value: 250,
            },
            {
                text: "500",
                value: 500,
            },
            {
                text: "1000",
                value: 1000,
            },
        ],
    };

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

    //onInit//
    useEffect(function () {
        fetchData();
    }, [props.gasYear]);
    //onInit//

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    const gotoMainMenu = () => {
        history.push({
            pathname: "/gas-delivery-performance-report", state: {  // location state
                goBack: true,
            },
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.ALIAS_NAME < b.ALIAS_NAME) {
            return -1;
        }
        if (a.ALIAS_NAME > b.ALIAS_NAME) {
            return 1;
        }
        return 0;
    }

    const fetchData = async () => {
        // console.log(props.gasYear);
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_DETAIL_GAS_PERFORMANCE_REPORT + "?YEAR=" + props.gasYear, {});
            // console.log(res);
            setModelListIndustrial(res.data.rpPerformanceListTSO.INDUSTRIAL);
            setModelListWholesale(res.data.rpPerformanceListTSO.WHOLESALE)
            // setModelListGasControl(res.data.rpPerformanceListGasControl);

            // setModelDeviceList(res.data.rpGasDeliveryAvgList);
            // .map((obj) => {
            //     return {
            //         ...obj, PLAN: numberFormat(obj.PLAN, 2), ACTUAL: numberFormat(obj.ACTUAL, 2), DIFF: numberFormat(obj.DIFF, 2), DAY: numberFormat(obj.DAY, 2),
            //         ACC_PLAN: numberFormat(obj.ACC_PLAN, 2), ACC_ACTUAL: numberFormat(obj.ACC_ACTUAL, 2)
            //     }
            // }));
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    function RenderListIndustrial(prop) {
        // console.log(prop);
        return (
            // <tr style={{ backgroundColor: prop.data.MONTH == "Overall" ? "#FFD1A2" : "#FFFFFF" }}>
            <tr style={{ ...(prop.inDex == modelListIndustrial.length - 1 && { backgroundColor: "#3454e438" }) }}>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{prop.data.MONTH}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{numberFormat(prop.data.GAS_DEVIERED, 2)}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{numberFormat(prop.data.GAS_DEMAND, 2)}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF", backgroundColor: prop.data.MONTH == "Overall" ? "#3454e438" : "#576dd136", }}>{numberFormat(prop.data.GAS_LOSS, 2)}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{numberFormat(prop.data.GAS_DEVIERED_GAS_DEMAND * 100, 2)} %</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{prop.data.GOAL == null ? "" : numberFormat(prop.data.GOAL, 2) + " %"} </td>
            </tr>
        );
    }

    function RenderListWholesale(prop) {
        // console.log(prop);
        return (
            // <tr style={{ backgroundColor: prop.data.MONTH == "Overall" ? "#FFD1A2" : "#FFFFFF" }}>
            <tr style={{ ...(prop.inDex == modelListWholesale.length - 1 && { backgroundColor: "#3454e438" }) }}>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{prop.data.MONTH}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{numberFormat(prop.data.GAS_DEVIERED, 2)}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{numberFormat(prop.data.GAS_DEMAND, 2)}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF", backgroundColor: prop.data.MONTH == "Overall" ? "#3454e438" : "#576dd136", }}>{numberFormat(prop.data.GAS_LOSS, 2)}</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{numberFormat(prop.data.GAS_DEVIERED_GAS_DEMAND * 100, 2)} %</td>
                <td className="text-center" style={{ color: prop.data.MONTH == "Overall" ? "#FFF271" : "#FFFFFF" }}>{prop.data.GOAL == null ? "" : numberFormat(prop.data.GOAL, 2) + " %"} </td>
            </tr>
        );
    }

    return (
        <React.Fragment>
            <Row>
                <Col
                    sm="12"
                    className="d-flex align-items-center justify-content-end"
                >
                    <div className="d-grid gap-2 d-md-block">
                        <Button
                            onClick={() => gotoMainMenu()}
                            // className="btn-rounded"
                            color="secondary"
                            className="mt-0 mb-0"
                        >
                            <i className="fas fa-angle-double-left"></i>
                            &nbsp; Back
                        </Button>
                    </div>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col sm="12">
                    <div style={{ width: "100%" }}>
                        <Table className="table table-bordered table-striped mb-0">
                            <thead style={{ fontSize: "1.5vh" }}>
                                <tr>
                                    <th rowSpan={2} style={{ backgroundColor: "#485ec3", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Month</th>
                                    <th colSpan={4} style={{ backgroundColor: "#485ec3", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>รายใหญ่ ( <b style={{ color: "#FE96FA", }}>All-รายย่อย </b> ) EGAT IPP SPP </th>

                                </tr>
                                <tr>
                                    <th style={{ backgroundColor: "#485ec3", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Delivery ( MMscfd )</th>
                                    <th style={{ backgroundColor: "#485ec3", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Demand ( MMscfd )</th>
                                    <th style={{ backgroundColor: "#485ec3", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Loss from SD ( MMscfd )</th>
                                    <th style={{ backgroundColor: "#485ec3", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Delivery/Gas Demand</th>
                                    <th style={{ backgroundColor: "#6e82e1f5", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Goal</th>

                                </tr>
                            </thead>
                            <tbody style={{ textAlign: "center", fontSize: "1.6vh", fontWeight: "bold" }}>
                                {/* backgroundColor: "#FFFFFF", color: "#000000",  */}
                                {modelListWholesale.map((value, index) => (<RenderListWholesale key={index} data={value} indexlist={index + 1} inDex={index} />))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col sm="12">
                    <div style={{ width: "100%" }}>
                        <Table className="table table-bordered table-striped mb-0">
                            <thead style={{ fontSize: "1.5vh" }}>
                                <tr>
                                    <th rowSpan={2} style={{ backgroundColor: "#465192", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Month</th>
                                    <th colSpan={4} style={{ backgroundColor: "#465192", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>อุตสาหกรรม ( <b style={{ color: "#FE96FA", }}>IND + NGV + NGD </b> ) ไม่รวม Fuel </th>

                                </tr>
                                <tr>
                                    <th style={{ backgroundColor: "#465192", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Delivery ( MMscfd )</th>
                                    <th style={{ backgroundColor: "#465192", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Demand ( MMscfd )</th>
                                    <th style={{ backgroundColor: "#465192", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Loss from SD ( MMscfd )</th>
                                    <th style={{ backgroundColor: "#465192", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Gas Delivery/Gas Demand</th>
                                    <th style={{ backgroundColor: "#555C83", color: "#FFFFFF", textAlign: "center", width: "10%", fontWeight: "bold" }}>Goal</th>

                                </tr>
                            </thead>
                            <tbody style={{ textAlign: "center", fontSize: "1.6vh", fontWeight: "bold" }}>
                                {/* backgroundColor: "#FFFFFF", color: "#000000", */}
                                {modelListIndustrial.map((value, index) => (<RenderListIndustrial key={index} data={value} indexlist={index + 1} inDex={index} />))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>

        </React.Fragment >
    );
}

TabTSO.propTypes = {
    t: PropTypes.any,
    gasYear: PropTypes.any,
};


export default TabTSO;
